import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { commonHttpClient } from './http-clients/common-http-client'

export interface ContactField {
  id: number
  fieldName: string
  slug: ContactSlugEnum
}

export const fetchContactFields = async (): Promise<ContactField[]> => {
  const response = await commonHttpClient.get(
    '/api/dashboard/customer/contact/fields/list',
  )
  return response.data.items
}
